const {
  GET_ALL_ARTICLE_REQUEST,
  GET_ALL_ARTICLE_SUCCESS,
  GET_ALL_ARTICLE_FAIL,
  DELETE_ARTICLE_REQUEST,
  DELETE_ARTICLE_SUCCESS,
  DELETE_ARTICLE_FAIL,
  ADD_ARTICLE_REQUEST,
  ADD_ARTICLE_SUCCESS,
  ADD_ARTICLE_FAIL,
  UPDATE_ARTICLE_REQUEST,
  UPDATE_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_FAIL,
} = require("../../actionTypes/Paramaetrage/Article");

function getAllArticles(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_ARTICLE_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_ARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_ARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}
function addArticle(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_ARTICLE_REQUEST:
      return { loading: true, data: {} };
    case ADD_ARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_ARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateArticle(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_ARTICLE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_ARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_ARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}
function deleteArticle(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_ARTICLE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_ARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_ARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}
export { getAllArticles, deleteArticle, addArticle, updateArticle };
